var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { loginDestinationFor } from 'lib/returnPath';
import FormStateStore from 'stores/FormStateStore/store';
import ClientStateStore from 'stores/ClientStateStore/store';
import { requestActivationCode, checkActivationStatus } from 'actions/ServerActionCreators';
import { FormStateSchema } from 'types/formState';
import UniqueId from 'utils/UniqueId';
import Logo from '../shared/Logo';
function getStateFromStores(id) {
    var formState = FormStateStore.getFormState(id);
    return {
        error: formState.state === FormStateSchema.Enum.FAILURE,
        loggedIn: ClientStateStore.isLoggedIn() || false,
        activationCode: ClientStateStore.getClientKey('activationCode') || '',
        formState: formState
    };
}
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.leaving = false;
        _this.UniqueId = UniqueId();
        _this.state = getStateFromStores(_this.UniqueId);
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_this);
        requestActivationCode(_this.UniqueId);
        return _this;
    }
    Login.prototype.componentDidMount = function () {
        ClientStateStore.addChangeListener(this.onChangeHandler);
        FormStateStore.addChangeListener(this.onChangeHandler);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        this.leaveIfSignedIn();
    };
    Login.prototype.componentDidUpdate = function () {
        this.leaveIfSignedIn();
    };
    Login.prototype.componentWillUnmount = function () {
        ClientStateStore.removeChangeListener(this.onChangeHandler);
        FormStateStore.removeChangeListener(this.onChangeHandler);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    };
    Login.prototype.handleVisibilityChange = function () {
        // When the app resumes from background, check if activation was completed
        // This handles the case where Pusher websocket was disconnected while app was suspended
        if (document.visibilityState === 'visible' && this.state.activationCode) {
            checkActivationStatus(this.state.activationCode, this.UniqueId);
        }
    };
    Login.prototype.onChangeHandler = function () {
        this.setState(getStateFromStores(this.UniqueId));
    };
    Login.prototype.getErrorMessage = function () {
        if (!this.state.error) {
            return '';
        }
        return (_jsx("div", { className: "ui-message-container--error", children: _jsxs("div", { className: "ui-message-body", children: [_jsx("i", { className: "icon ion-information-circled ui-message-icon" }), _jsx("span", { className: "ui-message-text", children: "Invalid email or password." })] }) }));
    };
    Login.prototype.clearErrors = function () {
        this.setState({ error: false });
    };
    // SCO-593: a signed-in visitor bound outside the bundle leaves by document
    // navigation — from a lifecycle, never from render (StrictMode renders twice).
    Login.prototype.leaveIfSignedIn = function () {
        if (this.state.loggedIn && this.props.destination.leavesBundle && !this.leaving) {
            this.leaving = true;
            window.location.assign(this.props.destination.to);
        }
    };
    Login.prototype.render = function () {
        // const submitText = this.state.formState.state === FormState.LOADING ?
        // 'Loading...' : 'Log In';
        if (this.state.loggedIn) {
            if (this.props.destination.leavesBundle) {
                return null;
            }
            return _jsx(Navigate, { to: this.props.destination.to });
        }
        return (_jsx("div", { className: "h-full scroll-smooth antialiased [font-feature-settings:'ss01'] flex flex-col", children: _jsxs("div", { className: "relative flex min-h-full justify-center", children: [_jsx("div", { className: "relative z-10 flex flex-1 flex-col bg-white py-10 px-4 shadow-2xl justify-center md:px-28", children: _jsxs("div", { className: "flex flex-col justify-center items-center text-center", children: [_jsx(Logo, { className: "h-10 w-auto" }), _jsxs("div", { className: "mt-12", children: [_jsxs("p", { className: "text-xl text-gray-900", children: ["Visit", ' ', _jsx("span", { className: "font-semibold", children: "scoreboardbuzz.com/activate" }), ' ', "in your web browser and enter the following code:"] }), _jsx("p", { className: "text-2xl text-gray-900 font-semibold mt-4", children: this.state.activationCode })] })] }) }), _jsx("div", { className: "hidden sm:contents" })] }) }));
    };
    return Login;
}(React.Component));
var LoginWrapper = function () {
    var navigate = useNavigate();
    var search = useLocation().search;
    var destination = loginDestinationFor(search, '/mobile/authorized');
    // THIS IS A REALLY HACKY WAY TO DO THIS, BUT MORE REFACTORING IS NEEDED TO AVOID IT
    // DOING A NAVIGATE DURING A RENDER IS NOT ALLOWED, THIS GETS AROUND IT
    var _a = useState(null), navigateTo = _a[0], setNavigateTo = _a[1];
    useEffect(function () {
        if (navigateTo) {
            setNavigateTo(null);
            navigate(navigateTo);
        }
    }, [navigateTo, navigate]);
    return (_jsx(Login, { navigate: function (newUrl) { return setNavigateTo(newUrl); }, destination: destination }));
};
export default LoginWrapper;
